module.exports = __webpack_public_path__ + "static/media/FuturaPTDemi.5b6575cc.otf";